<script>
import { Pie } from "vue-chartjs";
import ChartAnnotations from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  extends: Pie,
  plugins: [ChartAnnotations, ChartDataLabels],
  props: {
    data: Object,
    options: Object,
  },
  watch: {
    data() {
      this.renderChart(this.data, this.options);
    },
    options() {
      this.renderChart(this.data, this.options);
    },
  },
  mounted() {
    this.renderChart(this.data, this.options);
  },
};
</script>
